import {isBrowser} from '@shopify/hydrogen';
import ReactPlayer from 'react-player';
import {wrapper, videoModal, teaserVideo} from './fluidVideo.module.css';

type Props = {
  className?: string;
  teaser?: boolean;
  url: string;
  playing?: boolean;
  loop?: boolean;
  muted?: boolean;
  controls?: boolean;
  playsinline?: boolean;
  light?: boolean;
};

export default function FluidVideo({className, teaser, url, ...props}: Props) {
  return (
    <div
      className={`${className} ${wrapper} ${videoModal} ${
        teaser && teaserVideo
      }`}
    >
      {isBrowser() && <ReactPlayer url={url} {...props} />}
    </div>
  );
}
